import LocationPageTemplate from '../LocationPageTemplate';
import { locationFaqs } from '../../../mocks/faqs';

export default function TampaPage() {
  return (
    <LocationPageTemplate
      city="Tampa"
      heroImage="https://www.parksidepavers.com/files/projects/14/images/thumb/thumb_large_IMG%5F2835%2Ejpg"
      description="Expert paver installation in Tampa, FL — custom driveways, patios, pool decks, walkways, and full outdoor living spaces for Tampa Bay homeowners and businesses."
      geoDescription="Parkside Pavers provides professional paver installation across Tampa, offering custom hardscape solutions for every home style and budget. Paver installation in Tampa, patio design in Tampa, and driveway pavers near Tampa — we do it all."
      mapEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d112946.68891040516!2d-82.53090219999999!3d27.994402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c3f3b3f3b3f3%3A0x0!2sTampa%2C%20FL!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
      faqs={locationFaqs.tampa}
    />
  );
}
